import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function IsStresiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['is-stresi-testi']} />;
}
